// extracted by mini-css-extract-plugin
export default {"calendarWrap":"SmartSkladPage_calendarWrap__tvXSH"};